import { render, staticRenderFns } from "./auth_group.vue?vue&type=template&id=1aba4955&"
import script from "./auth_group.vue?vue&type=script&lang=js&"
export * from "./auth_group.vue?vue&type=script&lang=js&"
import style0 from "./auth_group.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports